import { Triangle } from "react-loader-spinner";
import { TypeAnimation } from "react-type-animation";

const Loading = () => {
  return (
    <div className="loading">
      <Triangle
        visible={true}
        height="100"
        width="100"
        color="#0044cc"
        ariaLabel="triangle-loading"
      />
      <div className="loading-text">
        <TypeAnimation
          sequence={[
            // Same substring at the start will only be typed once, initially
            "Aguarde, estamos trabalhando\n por você",
            1000,
            "Aguarde, estamos trabalhando\n para você",
            1000,
            "Aguarde, estamos trabalhando\n para seu conforto",
            1000,
            "Aguarde, estamos trabalhando\n para sua segurança",
            1000,
          ]}
          speed={50}
          style={{ whiteSpace: "pre-line" }}
          repeat={Infinity}
        />
      </div>
    </div>
  );
};

export default Loading;
